module.exports = __webpack_public_path__ + "static/confirmation-2540842985109699ce1aae5a0ebc1fef.png";